<template>
  <div v-if="showComponent" class="row box">
    <div class="small-12 columns gap">
      <h2 v-html="vueModel.title" />
    </div>
    <div class="small-6 columns gap">
      <call /><a data-test-pa-phone :href="`tel:${numberLink}`" v-html="vueModel.number" />
    </div>
    <div class="small-6 columns gap">
      <opening-hours
        :opening-hours="vueModel.openingHours"
        :open-description="vueModel.openDescription"
        :closed-description="vueModel.closedDescription"
      />
    </div>
    <div class="small-12 columns gap">
      <support /><a
        data-test-pa-modal-link
        href="#"
        @click="showCallMeModal(true)"
        v-html="vueModel.callMeLinkLabel"
      />
    </div>
    <call-me-modal
      :show-modal="showModal"
      :data-source="vueModel.callMeDataItemId"
      :title="vueModel.callMeModalTitle"
      :description="vueModel.callMeModalDescription"
      :open-description="vueModel.openDescription"
      :closed-description="vueModel.closedDescription"
      @hide-personal-assistance-modal="showCallMeModal(false)"
    />
  </div>
</template>

<script lang="ts">
import Call from './Icons/Call.vue';
import CallMeModal from './CallMeModal/CallMeModal.vue';
import Support from './Icons/Support.vue';
import OpeningHours from './OpeningHours/OpeningHours.vue';
import { PersonalAssistanceModel } from './types/PersonalAssistance';
import { ApiResponse } from '@/interfaces/RequestService';
import RequestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PersonalAssistance',
  components: {
    Call,
    CallMeModal,
    OpeningHours,
    Support
  },
  props: {
    dataSource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      vueModel: {} as PersonalAssistanceModel,
      showComponent: false,
      showModal: false
    };
  },
  computed: {
    numberLink(): string {
      if (!this.vueModel.number) {
        return '';
      }
      return this.vueModel.number.replace(/[^0-9+]/g, '');
    }
  },
  created() {
    const url = Utility.constants().API.personal_assistance_get;
    RequestService.get<PersonalAssistanceModel>(url, {}, 'json', { id: this.dataSource })
      .then((response: ApiResponse<PersonalAssistanceModel>) => {
        this.vueModel = response.data;
        this.showComponent = true;
      })
      .catch((err) => Utility.logError(err, this));
  },
  methods: {
    showCallMeModal(val: boolean): void {
      this.showModal = val;
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.box {
  background-color: $background-light;
  padding: rem-calc(24px) rem-calc(16px);

  h2 {
    color: $black;
    font-size: rem-calc(24px);
    margin: 0;
    width: 100%;
  }

  a {
    font-size: rem-calc(16px);
    font-weight: 500;
    text-decoration: none;
  }

  .gap {
    margin-bottom: rem-calc(48px);
    display: flex;
    align-items: center;
  }
}
</style>
